/**
 * 내비게이션 번역 - 한국어
 * Navigation translations - Korean
 */

export default {
  home: '홈',
  coreService: '핵심 서비스',
  industrySolutions: '산업별 솔루션',
  caseStudies: '사례 소개',
  resourceCenter: '리소스 센터',
  customerSupport: '고객 지원',
  about: '회사 소개',
  contact: '문의하기',
  search_placeholder: '기술 관련 질문이 있으신가요? AI 엔진이 도와드립니다.'
}
